import { memo, useCallback } from "react";

// UI
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import VehicleDamageDropdown from "ui/components/Dropdown/VehicleDamageDropdown/VehicleDamageDropdown";
import { DatePicker } from "ui/components/DatePicker";
import { TextArea } from "ui/components/TextField/TextArea";

import { getStatusField } from "../fields";
import { VehicleStatusFieldsProps } from "../types";

/**
 * Nedostupno – Šteta. Odgovara `VehicleStatusDamageDetail` na backendu — šteta je obavezna.
 */
const VehicleStatusDamageFields: React.FC<VehicleStatusFieldsProps> = (props) => {
  const { status, vehicleId, values, errors, onChange } = props;

  const damageField = getStatusField(status, "damage");
  const validUntilField = getStatusField(status, "validUntil");
  const noteField = getStatusField(status, "note");

  const handleDropdownChange = useCallback(
    (_e: any, name: string, item: DropdownOption) => {
      onChange({ [name]: item.value || null });
    },
    [onChange]
  );

  const handleDateChange = useCallback(
    (name: string, value: Date | null) => {
      onChange({ [name]: value });
    },
    [onChange]
  );

  const handleTextChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target;
      onChange({ [name]: value });
    },
    [onChange]
  );

  // Šteta i rok popravka idu u par; napomena je duži tekst pa uzima cijeli redak.
  return (
    <div className="grid grid-cols-2 gap-3">
      {damageField && (
        <div>
          <VehicleDamageDropdown
            name="vehicleDamageId"
            label={damageField.label}
            placeholder="Odaberite štetu"
            vehicleId={vehicleId}
            value={values.vehicleDamageId}
            onChange={handleDropdownChange}
            error={errors.vehicleDamageId}
            required={damageField.required}
            width="full"
          />
        </div>
      )}

      {validUntilField && (
        <div>
          <DatePicker
            name="validUntil"
            label={validUntilField.label}
            placeholder={validUntilField.label}
            value={values.validUntil}
            onChange={handleDateChange}
            error={errors.validUntil}
            required={validUntilField.required}
            width="full"
          />
        </div>
      )}

      {/* Opis štete se piše u par rečenica, ne u jedan redak. */}
      {noteField && (
        <div className="col-span-2">
          <label className="block text-sm mb-2 font-medium leading-6 text-[#344054]">
            {noteField.label}
            {noteField.required && <span className="text-red-500"> *</span>}
          </label>
          <TextArea
            name="note"
            placeholder={noteField.label}
            value={values.note}
            onChange={handleTextChange}
            error={errors.note}
            rows={6}
            size="full"
          />
        </div>
      )}
    </div>
  );
};

export default memo(VehicleStatusDamageFields);
